import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import strings from "../../../../utils/strings";
import Widgets from "../../../../widgets";
import ServiceType from "../CreateService/ServiceType";
import "./ManageRequestServiceDetail.css";
const dummyOptions = [
  { value: "home", label: "Home" },
  { value: "work", label: "Work" },
  { value: "relative", label: "Relative" },
  { value: "other", label: "Other" },
];

const ManageRequestServiceDetails = () => {
  const { t } = useTranslation();
  const breadcrumbs = ["nursingCare", "manageService", "serviceDetails"];
  const paths = [strings.navigation.nursingCareManageService, strings.navigation.nursingCareManageService, strings.navigation.serviceDetail];
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const handleDelete = () => {
    setIsDeleteOpen(true);
  };
  const handleCancelDelete = () => {
    setIsDeleteOpen(false);
  };
  return (
    <div className="mr-container">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="department-heading-row">
        <div className="manage-service-heading">{t("xopd")}</div>
        <div className={`mr-status-btn`} onClick={handleDelete}>
          {t("delete")}
        </div>
      </div>

      <div className="create-service-main">
        <div>
          {" "}
          <ServiceType />
        </div>
        <div className="whp-container">
          <div className="title-hr">
            <p>{t("priceWorkingHour")}</p>
            <hr />
          </div>
          <div className="service-type-main2">
            <div className="service-input-box">
              <span>
                {t("opdInterInsured")} <label>*</label>
              </span>
              <Widgets.NewSelectDropdown options={dummyOptions} placeholder={"$0"} big />
            </div>
            <div className="service-input-box">
              <span>
                {t("opdLocalInsured")} <label>*</label>
              </span>
              <Widgets.NewSelectDropdown options={dummyOptions} placeholder={"$0"} big />
            </div>
            <div className="service-input-box">
              <span>
                {t("opdSubsidized")} <label>*</label>
              </span>
              <Widgets.NewSelectDropdown options={dummyOptions} placeholder={"$0"} big />
            </div>
          </div>
        </div>
        <div className="whp-container">
          <div className="title-hr2">
            <p>{t("priceNonWorkingHour")}</p>
            <hr />
          </div>
          <p className="clickable-text">{t("sameAsWorkingHour")}</p>
          <div className="service-type-main2">
            <div className="service-input-box">
              <span>
                {t("opdInterInsured")} <label>*</label>
              </span>
              <Widgets.NewSelectDropdown options={dummyOptions} placeholder={"$0"} big />
            </div>
            <div className="service-input-box">
              <span>
                {t("opdLocalInsured")} <label>*</label>
              </span>
              <Widgets.NewSelectDropdown options={dummyOptions} placeholder={"$0"} big />
            </div>
            <div className="service-input-box">
              <span>
                {t("opdSubsidized")} <label>*</label>
              </span>
              <Widgets.NewSelectDropdown options={dummyOptions} placeholder={"$0"} big />
            </div>
          </div>
        </div>
      </div>
      <Widgets.ConfirmModal
        showModal={isDeleteOpen}
        handleCancel={handleCancelDelete}
        //  handleConfirm={handleConfirmDelete}
        heading="Delete Service"
        description="Are you sure to delete this service"
      />
    </div>
  );
};

export default ManageRequestServiceDetails;
